import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const FinancialAndSale = ({
  onChange,
  disabled,
  error,
  financial_title,
  sales_title,
  financial_sales,
  buyer_contacts,
  onContactsSearch,
  investor_providers,
  ...props
}) => {
  var data = {};

  const providers = investor_providers || [];
  const handleChange = event => {
    onChange(event, "financial_sales");
  };

  const pledge_status_options = [
    { id: "vigente", name: "Vigente" },
    { id: "vencida", name: "Vencida" },
    { id: "cancelada", name: "Cancelada" }
  ];

  const handleContactsAsyncChange = (event, values) => {
    if (!values) {
      values = { id: "" };
    }
    event.target.value = values.id;
    event.target.name = event.target.id;
    onChange(event, "financial_sales");
  };

  const handleContactsAsyncSearch = (event, values) => {
    onContactsSearch(values);
  };

  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {financial_title}
      </Typography>
      <div className="row">
        <div className="col-md-12">
          <Typography variant="subtitle1" className="mt-3">
            Datos de prenda
          </Typography>
        </div>
        <div className="col-md-2">
          <TextField
            id="pledgde_number"
            name="pledgde_number"
            label="Prenda Nro"
            disabled={disabled}
            type="text"
            placeholder="Ingrese el nro de prenda"
            onChange={handleChange}
            value={financial_sales.pledgde_number}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-2">
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="pledge_contact_id"
          >
            Empresa prenda
            <Select
              native
              name="pledge_contact_id"
              inputProps={{
                name: "pledge_contact_id",
                className: "pledge_contact_id"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              value={financial_sales.pledge_contact_id || ""}
              input={
                <Input id="grouped-native-select" name="pledge_contact_id" />
              }
            >
              <option value="" />
              {providers.map(investor_provider => (
                <option
                  key={investor_provider.contact_id}
                  id={investor_provider.contact_id}
                  value={investor_provider.contact_id}
                >
                  {investor_provider.contact &&
                  investor_provider.contact.hansa_code
                    ? investor_provider.contact.hansa_code + " - "
                    : ""}
                  {investor_provider.business_name}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-md-2">
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="pledge_status"
          >
            Estado prenda
            <Select
              native
              name="pledge_status"
              inputProps={{
                name: "pledge_status",
                className: "pledge_status"
              }}
              style={{ minWidth: 150, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              value={financial_sales.pledge_status || ""}
              input={<Input id="grouped-native-select" name="pledge_status" />}
            >
              <option value="" />
              {pledge_status_options.map(status => (
                <option key={status.id} id={status.id} value={status.id}>
                  {status.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="col-md-2">
          <TextField
            id="pledge_inscription_date"
            name="pledge_inscription_date"
            label="Fecha inscripción prenda"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de inscripción"
            onChange={handleChange}
            value={financial_sales.pledge_inscription_date || ""}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-2">
          <TextField
            id="pledge_03_number"
            name="pledge_03_number"
            label="Nro. formulario 03"
            disabled={disabled}
            placeholder="Ingrese el número de 03"
            onChange={handleChange}
            value={financial_sales.pledge_03_number || ""}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-2">
          <NumberFormat
            id="pledge_amount"
            name="pledge_amount"
            label="Monto prenda"
            disabled={disabled}
            placeholder="Ingrese el monto de prenda"
            onChange={handleChange}
            value={financial_sales.pledge_amount || ""}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            customInput={TextField}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
            thousandSeparator={true}
            prefix={"$"}
          />
        </div>
        <div className="col-md-2">
          <TextField
            id="pledge_dnrpa_cancelled_at"
            name="pledge_dnrpa_cancelled_at"
            label="Fecha cancelación DNRPA"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de cancelación DNRPA"
            onChange={handleChange}
            value={financial_sales.pledge_dnrpa_cancelled_at || ""}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>

        <div className="col-md-2">
          <TextField
            id="pledgde_duedate"
            name="pledgde_duedate"
            label="Prenda Vto."
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de vto de prenda"
            onChange={handleChange}
            value={financial_sales.pledgde_duedate}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
        <div className="col-md-2">
          <TextField
            id="pledgde_closure_date"
            name="pledgde_closure_date"
            label="Prenda Cierre"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de cierre de prenda"
            onChange={handleChange}
            value={financial_sales.pledgde_closure_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          />
        </div>
      </div>

      {/*<Typography variant="h6" className="mt-2">
            {sales_title}
        </Typography>

        <Autocomplete
            id={"buyer_contact_id"}
            style={{ width: 200 }}
            getOptionLabel={(option) => option.hansa_name}
            getOptionSelected={(option, value) => option.hansa_name === value}           
            options={buyer_contacts.options}
            loading={buyer_contacts.loading}
            value={buyer_contacts.options.find(v => v.id === financial_sales.buyer_contact_id) || {}}
            onInputChange={handleContactsAsyncSearch}
            onChange={handleContactsAsyncChange.bind(this)}
            autoComplete
            noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
            name={"buyer_contact_id"}
            includeInputInList
            className="mt-3 mr-2"
            classes={{
                option: classes.option,
            }}
            renderInput={(params) => (
            <TextField
                {...params}
                placeholder="Ingrese un contacto"
                name={"buyer_contact_id"}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <React.Fragment>
                        {buyer_contacts.loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                        </React.Fragment>
                    ),
                    }}
                    InputLabelProps={{ ...params.InputLabelProps,
                            shrink: true
                            }}
                    inputProps={{
                                ...params.inputProps,
                                style:{fontSize: '0.75rem', width: 70}
                            }}

            />
            )}
        />
        <TextField
            id="buyer_purchase_date"
            name="buyer_purchase_date"
            label="Fecha venta"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de venta"
            onChange={handleChange}
            value={financial_sales.buyer_purchase_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
            shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
        />

        <TextField
            id="buyer_transfer_date"
            name="buyer_transfer_date"
            label="Fecha tranferencia"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha de tranferencia"
            onChange={handleChange}
            value={financial_sales.buyer_transfer_date}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
            shrink: true
            }}
            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
        />*/}
    </React.Fragment>
  );
};

export default FinancialAndSale;
